import { LINE_ITEM_CATEGORIES, LINE_ITEM_CODES } from '../constants';
// import { createLog } from '../serverCalls';

// base invoice class for creating and getting invoices: no calculations here!!
export class PaymentInvoice {
	/**
	 * { [categoryKey]: { [groupKey]: LineItem[] } }
	 * { vehicles: { '123e4567-e89b-12d3-a456-426614174000': LineItem[] }, looseAccessories: { '123e4567-e89b-12d3-a456-426614174000': LineItem[] } }
	 */
	categories: Record<
		string,
		Record<
			string,
			{
				code: string;
				description: string;
				amount: number;
				quantity?: number;
				metadata?: Record<string, any>;
			}[]
		>
	>;
	metadata: Record<string, any>;

	constructor(categories = {}, metadata = {}) {
		this.categories = categories;
		this.metadata = metadata;
	}

	createCategory(categoryKey: string) {
		if (this.categories[categoryKey]) return;
		this.categories[categoryKey] = {};
	}

	createGroup(categoryKey: string, groupKey: string) {
		if (!this.categories[categoryKey]) this.createCategory(categoryKey);
		if (this.categories[categoryKey][groupKey]) return;
		this.categories[categoryKey][groupKey] = [];
	}

	createLineItem(
		categoryKey: string,
		groupKey: string,
		{
			code,
			description,
			amount,
			quantity = 1,
			metadata = {},
		}: {
			code: string;
			description: string;
			amount: number;
			quantity?: number;
			metadata?: Record<string, any>;
		},
	) {
		if (!this.categories[categoryKey] || !this.categories[categoryKey][groupKey]) {
			this.createGroup(categoryKey, groupKey);
		}
		this.categories[categoryKey][groupKey].push({
			code,
			description,
			amount,
			quantity,
			metadata,
		});
	}

	removeLineItem(categoryKey: string, groupKey: string, code: string) {
		this.categories[categoryKey][groupKey] = this.categories[categoryKey][groupKey].filter(
			(item) => item?.code !== code,
		);
	}

	removePaymentRelatedLineItems() {
		Object.keys(this.categories?.[LINE_ITEM_CATEGORIES.VEHICLES] || {}).forEach((groupKey) => {
			const items = this.categories[LINE_ITEM_CATEGORIES.VEHICLES][groupKey];
			this.categories[LINE_ITEM_CATEGORIES.VEHICLES][groupKey] = items.filter(
				(item) =>
					![
						LINE_ITEM_CODES.VEHICLE_ORDER_FEE,
						LINE_ITEM_CODES.VIP_RESERVATION_FEE,
						LINE_ITEM_CODES.FINANCING_DOWNPAYMENT,
						LINE_ITEM_CODES.PREV_PAID,
					].includes(item.code),
			);
		});
	}

	addMetadata(metadata: Record<string, any>) {
		this.metadata = {
			...this.metadata,
			...metadata,
		};
	}

	handleLineItemOverrides(lineItemsOverrides: Record<string, any>) {
		Object.keys(lineItemsOverrides).forEach((code) => {
			const override = lineItemsOverrides[code];
			if (!override || typeof override !== 'object') return;

			Object.keys(this.categories?.[LINE_ITEM_CATEGORIES.VEHICLES] || {}).forEach(
				(groupKey) => {
					const items = this.categories[LINE_ITEM_CATEGORIES.VEHICLES][groupKey];
					items.forEach((item) => {
						if (item.code === code) {
							Object.keys(override).forEach((key) => {
								if (key in item) {
									// @ts-expect-error
									item[key] = override[key];
								}
							});
						}
					});
				},
			);
		});
	}

	get() {
		return {
			categories: this.categories,
			metadata: this.metadata,
		};
	}

	getDefaultFees() {
		return Object.keys(this.categories?.[LINE_ITEM_CATEGORIES.VEHICLES] || {}).reduce(
			(
				acc: {
					code: string;
					description: string;
					amount: number;
					quantity?: number;
					metadata?: Record<string, any>;
				}[],
				groupKey: string,
			) => {
				const items = this.categories[LINE_ITEM_CATEGORIES.VEHICLES][groupKey];
				const defaulFeesItems = items.filter(
					(item) => !Object.values(LINE_ITEM_CODES).includes(item.code),
				);
				return [...acc, ...defaulFeesItems];
			},
			[],
		);
	}
}
